export default "__VITE_ASSET__BOkhYDtG__"